import React from "react";
import { Container, Button } from "shards-react";

const Forbidden = () => (
  <Container fluid className="main-content-container px-4 pb-4">
    <div className="error">
      <div className="error__content">
        <h2>401</h2>
        <h3>Ups!</h3>
        <p>No tenes permisos para acceder a este recurso.</p>
        <Button pill href="/contracts">&larr; Volver</Button>
      </div>
    </div>
  </Container>
);

export default Forbidden;
